import $ from "jquery";

$(document).on("ready turbolinks:load", function () {
  $(".event-tr-toggler").click(function (e) {
    const selector = $(this).data().toggleKey;

    $("." + selector).toggleClass("hidden");

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });
});
